import useText from '@/hooks/useText';
import { ACADEMIC_FORM_SHARED_TEXTS, ACADEMIC_FORM_RENEWAL_TEXTS } from '../constants/academicFormTexts';

/** Hook con todos los textos del formulario de renovación (i18n / src/locales) */
export function useAcademicRenewalFormTexts() {
  const shared = {
    questionMainReason: useText(ACADEMIC_FORM_SHARED_TEXTS.questionMainReason),
    questionUsageFrequency: useText(ACADEMIC_FORM_SHARED_TEXTS.questionUsageFrequency),
    questionUsefulness: useText(ACADEMIC_FORM_SHARED_TEXTS.questionUsefulness),
    questionSuggestions: useText(ACADEMIC_FORM_SHARED_TEXTS.questionSuggestions),
    questionAccess: useText(ACADEMIC_FORM_SHARED_TEXTS.questionAccess),
    selectFrequencyPlaceholder: useText(ACADEMIC_FORM_SHARED_TEXTS.selectFrequencyPlaceholder),
    selectAccessPlaceholder: useText(ACADEMIC_FORM_SHARED_TEXTS.selectAccessPlaceholder),
    suggestionsPlaceholder: useText(ACADEMIC_FORM_SHARED_TEXTS.suggestionsPlaceholder),
    errorMainReason: useText(ACADEMIC_FORM_SHARED_TEXTS.errorMainReason),
    errorUsageFrequency: useText(ACADEMIC_FORM_SHARED_TEXTS.errorUsageFrequency),
    errorUsefulness: useText(ACADEMIC_FORM_SHARED_TEXTS.errorUsefulness),
    errorAccess: useText(ACADEMIC_FORM_SHARED_TEXTS.errorAccess),
    btnCancel: useText(ACADEMIC_FORM_SHARED_TEXTS.btnCancel),
    btnSubmitting: useText(ACADEMIC_FORM_SHARED_TEXTS.btnSubmitting),
    drugTarget: useText(ACADEMIC_FORM_SHARED_TEXTS.drugTarget),
    genomicVariant: useText(ACADEMIC_FORM_SHARED_TEXTS.genomicVariant),
    biomarker: useText(ACADEMIC_FORM_SHARED_TEXTS.biomarker),
    instructors: useText(ACADEMIC_FORM_SHARED_TEXTS.instructors),
    students: useText(ACADEMIC_FORM_SHARED_TEXTS.students),
    bioinformatics: useText(ACADEMIC_FORM_SHARED_TEXTS.bioinformatics),
    other: useText(ACADEMIC_FORM_SHARED_TEXTS.other),
    otherSpecifyPlaceholder: useText(ACADEMIC_FORM_SHARED_TEXTS.otherSpecifyPlaceholder),
    errorApplicationTypeOther: useText(ACADEMIC_FORM_SHARED_TEXTS.errorApplicationTypeOther),
    usefulnessNotUseful: useText(ACADEMIC_FORM_SHARED_TEXTS.usefulnessNotUseful),
    usefulnessSlightly: useText(ACADEMIC_FORM_SHARED_TEXTS.usefulnessSlightly),
    usefulnessModerately: useText(ACADEMIC_FORM_SHARED_TEXTS.usefulnessModerately),
    usefulnessVery: useText(ACADEMIC_FORM_SHARED_TEXTS.usefulnessVery),
    usefulnessExtremely: useText(ACADEMIC_FORM_SHARED_TEXTS.usefulnessExtremely),
    webInterface: useText(ACADEMIC_FORM_SHARED_TEXTS.webInterface),
    restApi: useText(ACADEMIC_FORM_SHARED_TEXTS.restApi),
    r2Package: useText(ACADEMIC_FORM_SHARED_TEXTS.r2Package),
    cytoscape: useText(ACADEMIC_FORM_SHARED_TEXTS.cytoscape),
    aida: useText(ACADEMIC_FORM_SHARED_TEXTS.aida),
    questionMarketingConsent: useText(ACADEMIC_FORM_SHARED_TEXTS.questionMarketingConsent),
    marketingConsentYes: useText(ACADEMIC_FORM_SHARED_TEXTS.marketingConsentYes),
    marketingConsentNo: useText(ACADEMIC_FORM_SHARED_TEXTS.marketingConsentNo),
    errorMarketingConsent: useText(ACADEMIC_FORM_SHARED_TEXTS.errorMarketingConsent),
  };

  const renewal = {
    title: useText(ACADEMIC_FORM_RENEWAL_TEXTS.title),
    description: useText(ACADEMIC_FORM_RENEWAL_TEXTS.description),
    btnSubmit: useText(ACADEMIC_FORM_RENEWAL_TEXTS.btnSubmit),
    mainReasonDataQuality: useText(ACADEMIC_FORM_RENEWAL_TEXTS.mainReasonDataQuality),
    mainReasonEssential: useText(ACADEMIC_FORM_RENEWAL_TEXTS.mainReasonEssential),
    mainReasonRegularUse: useText(ACADEMIC_FORM_RENEWAL_TEXTS.mainReasonRegularUse),
    mainReasonInstitutional: useText(ACADEMIC_FORM_RENEWAL_TEXTS.mainReasonInstitutional),
    mainReasonOther: useText(ACADEMIC_FORM_RENEWAL_TEXTS.mainReasonOther),
  };

  return {
    ...shared,
    ...renewal,
    mainReasonOptions: [
      { value: 'data-quality', label: renewal.mainReasonDataQuality },
      { value: 'essential-project', label: renewal.mainReasonEssential },
      { value: 'regular-use', label: renewal.mainReasonRegularUse },
      { value: 'institutional-requirement', label: renewal.mainReasonInstitutional },
      { value: 'other', label: renewal.mainReasonOther },
    ],
    usageFrequencyOptions: [
      { value: 'drug-target', label: shared.drugTarget },
      { value: 'genomic-variant', label: shared.genomicVariant },
      { value: 'biomarker', label: shared.biomarker },
      { value: 'instructors', label: shared.instructors },
      { value: 'students', label: shared.students },
      { value: 'bioinformatics', label: shared.bioinformatics },
      { value: 'other', label: shared.other },
    ],
    accessOptions: [
      { value: 'web-interface', label: shared.webInterface },
      { value: 'rest-api', label: shared.restApi },
      { value: 'disgenet-package', label: shared.r2Package },
      { value: 'cytoscape', label: shared.cytoscape },
      { value: 'aida', label: shared.aida },
    ],
    usefulnessLabels: [
      shared.usefulnessNotUseful,
      shared.usefulnessSlightly,
      shared.usefulnessModerately,
      shared.usefulnessVery,
      shared.usefulnessExtremely,
    ],
  };
}
